import BaseTitleIcon from '@/components/PHR/BaseTitleIcon';
import BaseSegmented from '@/components/bases/BaseSegmented';
import FieldCondition from '@/screens/CreateEmr/FieldCondition';
import FormList from '@/screens/CreateEmr/FormList';
import { Col } from 'antd';
import _ from 'lodash';
import * as React from 'react';

export interface IRecursivelyCreateFormProps {
  emrType?: IEMRType;
  fields?: IFieldConfig[];
  groupKey?: string;
  listField?: any;
  parentNames?: any[];
  disabled?: boolean;
  isEdit?: boolean;
}

const isValidConfig = (config: any): config is IEMRType => {
  return config && typeof config === 'object' && 'fields' in config;
};

const RecursivelyCreateForm: React.FC<IRecursivelyCreateFormProps> = ({
  emrType,
  fields,
  groupKey,
  disabled,
  parentNames = ['data'],
  isEdit,
}) => {
  //   const form = Form.useFormInstance();
  //   const formValues = form.getFieldsValue();
  //   const allFieldsHaveValue = Object.values(formValues).every((value) => value !== undefined);
  const [tabShow, setTab] = React.useState<string>(emrType?.extra?.formDetail?.tabs?.[0].key || '');
  const fieldsAndGroups = emrType?.extra?.formDetail?.tabs?.find((d) => d.key === tabShow)?.fieldsAndGroups;
  return (
    <>
      {/* Tạo group */}
      {disabled && emrType?.extra?.formDetail?.type === 'tab' && (
        <div className="mb-4 sticky top-0 left-0 w-full z-10 bg-quick-modal">
          <BaseSegmented
            tab={tabShow}
            onClick={(key: string) => {
              setTab(key);
            }}
            items={
              emrType?.extra?.formDetail?.tabs?.map((d) => ({
                key: d.key,
                title: <div className="font-bold">{d.name}</div>,
                addClass: 'pr-[32px] pl-[32px]',
              })) || []
            }
          />
        </div>
      )}

      {emrType?.groups?.map((g, i) => {
        if (disabled && _.isArray(fieldsAndGroups) && !fieldsAndGroups.includes(g.key)) {
          return <React.Fragment key={i.toString()}></React.Fragment>;
        }

        const listFieldInGroup = emrType.format.fields?.filter((f) => f.group === g.key);

        return (
          <React.Fragment key={i.toString()}>
            {g.name && listFieldInGroup.length ? (
              <Col span={24}>
                <BaseTitleIcon src={g.icon} title={g.name} className="" />
              </Col>
            ) : (
              ''
            )}
            <RecursivelyCreateForm
              isEdit={isEdit}
              disabled={disabled}
              fields={listFieldInGroup}
              groupKey={g.key}
              parentNames={parentNames}
            />
          </React.Fragment>
        );
      })}

      {/* Tạo Field */}
      {fields?.map((f: IFieldConfig, i: number) => {
        // Nếu có trong group thì sẽ render ở group
        if (f.group && !groupKey) {
          return '';
        }

        // Nếu đặt config dạng tab mà nằm ngoài tab thì ko hiển thị
        if (
          disabled &&
          _.isArray(fieldsAndGroups) &&
          !(fieldsAndGroups.includes(f.group) || fieldsAndGroups.includes(f.key))
        ) {
          return <React.Fragment key={i.toString()}></React.Fragment>;
        }

        // Nếu có chưa sub thì sẽ render sub
        if (f?.emr && isValidConfig(f.emr)) {
          // Nếu là dạng multiple sẽ có add nhiều phần
          return (
            <FormList
              key={i.toString()}
              disabled={!!disabled}
              fieldConfig={f}
              parentNames={[...parentNames, f.key]}
              isEdit={isEdit}
            />
          );
        }

        // Bắt đầu tạo field ở đây
        return (
          <FieldCondition
            disabled={disabled}
            key={i.toString()}
            field={f}
            parentNames={[...parentNames]}
            isEdit={isEdit}
          />
        );
      })}
    </>
  );
};

export default RecursivelyCreateForm;
